'use strict';

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _Box = require('../atoms/Box');

var _Box2 = _interopRequireDefault(_Box);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

exports['default'] = function () {
  var defaultBoxed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function (WrappedComponent) {
    var Boxed = function (_Component) {
      _inherits(Boxed, _Component);

      function Boxed() {
        _classCallCheck(this, Boxed);

        return _possibleConstructorReturn(this, (Boxed.__proto__ || Object.getPrototypeOf(Boxed)).apply(this, arguments));
      }

      _createClass(Boxed, [{
        key: 'render',
        value: function render() {
          var _props = this.props,
              boxed = _props.boxed,
              box = _props.box,
              innerRef = _props.innerRef,
              props = _objectWithoutProperties(_props, ['boxed', 'box', 'innerRef']);

          var preventDesktopBehaviour = props.preventDesktopBehaviour;

          var wrappedComponent = _react2['default'].createElement(WrappedComponent, _extends({}, props, {
            boxed: boxed,
            box: box,
            ref: innerRef
          }));

          var element = wrappedComponent;

          if (boxed) {
            element = _react2['default'].createElement(_Box2['default'], _extends({}, box, {
              preventDesktopBehaviour: preventDesktopBehaviour
            }), wrappedComponent);
          }

          return element;
        }
      }]);

      return Boxed;
    }(_react.Component);

    Boxed.displayName = 'Boxed' + WrappedComponent.displayName;
    Boxed.propTypes = _extends({}, WrappedComponent.propTypes, {
      preventDesktopBehaviour: _propTypes2['default'].bool,
      boxed: _propTypes2['default'].bool,
      box: _propTypes2['default'].shape({
        bgColor: _Box2['default'].propTypes.bgColor,
        bgSrc: _Box2['default'].propTypes.bgSrc,
        top: _Box2['default'].propTypes.top,
        right: _Box2['default'].propTypes.right,
        bottom: _Box2['default'].propTypes.bottom,
        left: _Box2['default'].propTypes.left
      })
    });
    Boxed.defaultProps = _extends({}, WrappedComponent.defaultProps, {
      preventDesktopBehaviour: false,
      boxed: (0, _get2['default'])(WrappedComponent, 'defaultProps.boxed', defaultBoxed)
    });
    return (0, _hoistNonReactStatics2['default'])(Boxed, WrappedComponent);
  };
};